import { ReactElement } from 'react';
import { Text } from '../../components/Text';
import { BodyText, HelloText, NameText, Wrapper } from './Home.elements';
import { Link } from 'react-router-dom';
import { differenceInYears } from 'date-fns';
import avatar from '../../avatar.png';

export const Home = (): ReactElement => {
  return (
    <Wrapper>
      <HelloText>Hello.</HelloText>
      <NameText>I'm Chris.</NameText>
      <BodyText>
        <img src={avatar} alt="cartoon portrait of a software engineer" />
        <p>
          <Text>
            I'm a senior software engineer with over{' '}
            {differenceInYears(Date.now(), '2014-03-01')} years of professional
            experience, and a passion for building great software.
          </Text>
        </p>
        <p>
          <Text>
            Find out more <Link to="/about">about me</Link>, or get in{' '}
            <Link to="/contact">contact</Link>!
          </Text>
        </p>
      </BodyText>
    </Wrapper>
  );
};
